import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    franchiseProduct: null,
    franchiseProducts: null,
    isNew: false,
    lastState: null,
    lastScope: null,
    message: null,
};

const franchiseProductTemplateReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.FRANCHISEPRODUCTTEMPLATE_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.FRANCHISEPRODUCTTEMPLATE_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.FRANCHISEPRODUCTTEMPLATE_FAIL: {
            return updateState(state, { ...action.error, lastState: constants.STATE_FAIL });
        }
        case actionTypes.FRANCHISEPRODUCTTEMPLATE_RESET: {
            return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
        }
        default: {
            return state;
        }
    }
};

export default franchiseProductTemplateReducer;
